import React from 'react'
import './Founder.css';

const Founder = () => {
  return (
    <div>
        <h1 className='founder_header'>    Welcome To Sai Shanti Vidya Niketan</h1>
        <div className='founder_main_container'>
        
        <div className='school_founder_paragraph'>
            <p> Sai Shanti Vidya Niketan was founded in 2004 by Mrs. Chandana Behera with a vision to create an institution that offers high-quality early childhood education. Mrs. Behera’s dedication to education and her passion for nurturing young minds laid the foundation for what has become a nurturing and stimulating environment for children. Guided by her belief that early education shapes the future of individuals, Mrs. Behera sought to instill a love for learning in every child. 
              With a deep commitment to fostering creativity, curiosity, and moral values, her goal was to build an institution where young children could receive a well-rounded education in a supportive and enriching setting.

Over the years, Sai Shanti Vidya Niketan has grown into a beacon of excellence, embodying Mrs. 
Behera's vision of empowering young learners to reach their full potential. The institution has consistently focused on the holistic development of children, ensuring they grow not just academically, but also emotionally and socially. With a dedicated team of educators who share Mrs. Behera’s vision, the school has cultivated an environment where children are encouraged to explore, discover, and thrive. Sai Shanti Vidya Niketan continues to uphold its founder’s legacy, remaining steadfast in its mission to provide an education that shapes not just the mind, but the character of each child.
                </p>
        </div>
        <div>
         <img className='founder_img' src="./teacher.jpg" alt="" />
        </div>
    </div>
    </div>
  )
}

export default Founder